import { animateOnScroll } from "./components/animate-on-scroll.js";
import { gridDebug } from "./components/grid-debug.js";
import Slider from "./components/sliders";

document.addEventListener("DOMContentLoaded", (event) => {
	const $body = document.body;
	animateOnScroll.init();
	// gridDebug.init();

	let programs_mobile = document.querySelector(".grid-program--sm");
	if (programs_mobile) {
		let swiper = programs_mobile.querySelector(".swiper");

		if (swiper) {
			Slider.initSwiper(swiper, {
				slidesPerView: 1.1,
				centeredSlides: true,
				pagination: {
					el: ".swiper-pagination",
					type: "bullets",
				},
			});
		}
	}

	// const translateRowGrid = () => {
	// 	let hexa_box = document.querySelector(".hexa-box");
	// 	let hexa_box_width = hexa_box.getBoundingClientRect().width / 2;
	// 	let hexa_box_pos = hexa_box.getBoundingClientRect().left;
	// 	let row_pos = hexa_box_width + hexa_box_pos;
	// 	document.querySelector("[data-offset]").style.translate = `${row_pos / 2}px 0`;
	// };

	// translateRowGrid();
	// window.addEventListener("resize", translateRowGrid);
});
